import React from 'react';

import { transparentize } from 'polished';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  Carousel,
  useBreakpoint,
  desktop,
} from '~/techstyle-shared/react-components';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 0 118px;
`;

const StyledAssetContainer = styled(AssetContainer)`
  ${desktop`
    border-radius: 16px;
    overflow: hidden;
  `}
`;

const cellStyle = css`
  width: 309px;
  margin-right: 4px;
`;

const StyledCarousel = styled(Carousel).attrs({
  cellAlign: 'center',
  wrapAround: true,
  cellStyle,
})`
  .flickity-page-dots {
    // move up underlying flickity dots
    bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .dot {
      background: ${({ theme }) =>
        transparentize(0.5, theme.colors.palette.black)};
      width: 6px;
      height: 6px;
      margin: 0 2px;
    }

    .dot.is-selected {
      background: ${({ theme }) => theme.colors.palette.black};
      width: 8px;
      height: 8px;
    }
  }
`;

const CompressionGuideCarousel = ({ images = {} }) => {
  const { isMobile } = useBreakpoint();
  const { desktop: desktopImages = [], mobile = [] } = images;
  const imageSelection = isMobile ? mobile : desktopImages;

  const Container = isMobile ? StyledCarousel : Grid;

  return (
    <Container prevNextButtons={false}>
      {imageSelection.map((image) => (
        <StyledAssetContainer key={image} name={image} />
      ))}
    </Container>
  );
};

CompressionGuideCarousel.propTypes = {
  images: PropTypes.object,
};

export default CompressionGuideCarousel;
